import styled from "styled-components";

export const TenantListWrapper = styled.div`
    height: 100%;
`

export const TenantTableWrapper = styled.div`
    height: calc(100% - 100px);
`

export const TenantActionWrapper = styled.div`
    
`